import script from "./ShenSha.vue?vue&type=script&setup=true&lang=js"
export * from "./ShenSha.vue?vue&type=script&setup=true&lang=js"

import "./ShenSha.vue?vue&type=style&index=0&id=1d611875&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d611875"]])

export default __exports__